// extracted by mini-css-extract-plugin
export var adaptive = "MarkdownMediaGroup-module--adaptive--e1f02";
export var mode_grow = "MarkdownMediaGroup-module--mode_grow--b3916";
export var mode_shrink = "MarkdownMediaGroup-module--mode_shrink--eca78";
export var root = "MarkdownMediaGroup-module--root--20571";